// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2V3Re","inner":"Form_inner__fRDTT","range":"Form_range__1T9Ld","name":"Form_name__WGaOJ","actions":"Form_actions__6fz6K"};